// extracted by mini-css-extract-plugin
export var cancelButton = "_nj-5";
export var content = "_nj-3";
export var createButton = "_nj-6";
export var drawerContainer = "_nj-0";
export var footer = "_nj-2";
export var header = "_nj-1";
export var orderFormColumn = "_nj-4";